import { useAuthContext } from "newui/features/Auth/context/AuthContextProvider";
import { GUEST_INVITE_TYPE } from "constants/guest";
import { useNavigate } from "@reach/router";
import { useCallback } from "react";
import { GuestInviteType } from "types/auth.types";
import { Rfx } from "../types/rfx.types";
import { RFX_TABS } from "utils/constants";

export interface RFxCardData {
	id?: number;
	invite_type: GuestInviteType;
	rfq?: Rfx;
	rfqId?: number;
	status?: string;
	submittedAt?: string;
}

export const useSupplierRfxNavigator = () => {
	const { guestPaths, supplierPaths } = useAuthContext();
	const navigate = useNavigate();

	return useCallback(
		(rfxData: RFxCardData, tabId: string | null = null) => {
			if (!rfxData) {
				return;
			}

			const rfxId = rfxData.rfqId ?? rfxData.rfq?.id;
			const rfx = rfxData.rfq;

			const initialTab =
				tabId ??
				(rfx?.hasDocumentation ||
				(rfx?.documentationDocument?.length &&
					rfx?.documentationDocument.length > 0)
					? RFX_TABS.DOCUMENTATION
					: RFX_TABS.QUESTIONNAIRE);

			if (rfxData.invite_type === GUEST_INVITE_TYPE.RFX_PRE_APPROVER) {
				navigate(guestPaths.viewRfxApproval(rfxId));
				return;
			}

			if (rfxData.invite_type === GUEST_INVITE_TYPE.RFX_EVALUATION_PANEL) {
				navigate(guestPaths.viewRfxEvaluationPanel(rfxId));
				return;
			}

			if (rfxData.invite_type === GUEST_INVITE_TYPE.RFX_SUPPLIER) {
				navigate(guestPaths.viewRfxSubmission(rfxId, initialTab));
				return;
			}

			navigate(supplierPaths.viewRfxSubmission(rfxId, rfxData.id, initialTab));
		},
		[navigate, guestPaths, supplierPaths]
	);
};
